import RadioButton from "@client/controls/Inputs/RadioButton/component";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { FormStyleContext } from "@common/contexts/FormStyle";
import { getRadioButtonGroupStyle, getRadioButtonStyle } from "@common/controls/Inputs/Radio/lib";
import { useI18n } from "@common/hooks/i18n";
import { sortBy } from "lodash";
import * as React from "react";
import { type Checkout } from "../../types";
import CartItem from "../CartItem";

export type MapProps = WithIsVisibleHOCProps & {
  currencyCode: string;
  isMobile: boolean;
  items: Checkout.Api.CartItem[];
  noImageUrl: string;
  productVariantId: string | null;
  productOptions: Checkout.ProductOption[];
};
export interface ActionProps {
  onChange: (variantId: string) => void;
}

export default withIsVisibleHOC((props: ActionProps & MapProps) => {
  const i18n = useI18n();

  const { fieldStyle } = React.useContext(FormStyleContext);

  const productName = React.useMemo(
    () => (
      <div>
        {props.items[0].name}&nbsp;
        {sortBy(props.productOptions, (x) => x.sortOrder).reduce((res, x, i) => {
          const value = x.name.toLowerCase();
          if (!res) return value;

          return i === props.productOptions.length - 1 ? `${res} ${i18n.and} ${value}` : `${res}, ${value}`;
        }, "")}
      </div>
    ),
    [props.items, props.productOptions]
  );

  return (
    <div className="variants">
      <h4>{i18n.product}</h4>

      {productName}
      <div className="items" style={getRadioButtonGroupStyle(fieldStyle)}>
        {props.items.map((x, i) => (
          <CartItem
            key={x.id}
            isNameHidden
            isActive={props.productVariantId === x.id}
            isMobile={props.isMobile}
            currencyCode={props.currencyCode}
            item={x}
            noImageUrl={props.noImageUrl}
            onClick={() => props.onChange(x.id)}
            prepend={<RadioButton isChecked={props.productVariantId === x.id} name="variant" value={x.id} />}
            style={getRadioButtonStyle(
              i,
              props.items.length,
              props.items.findIndex((y) => y.id === props.productVariantId),
              fieldStyle
            )}
          />
        ))}
      </div>
    </div>
  );
});
